import React from 'react';
import PropTypes from 'prop-types';

import { Modal, ModalHeader, ModalBody} from 'reactstrap';

const ModifyRateModal = (props) => {

  let { isOpen, toggle } = props;
  return (

    <Modal isOpen={isOpen} toggle={toggle} className={'modal-lg modal-primary'}>
      <ModalHeader toggle={toggle}> Preview/Apply Change </ModalHeader>
      <ModalBody>
        {props.children}
      </ModalBody>
    </Modal>
  );
};

ModifyRateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default ModifyRateModal;


// WEBPACK FOOTER //
// ./src/components/RateManagment/ModifyRateModal.js